<template>
  <ViewContainer
    data-testid="homeView-container-greeting"
    data-tourid="home-section-menu"
    :title="
      $t('home.hello', {
        name: userName,
        interpolation: { escapeValue: false },
      })
    "
  >
    <v-row class="relative mt-0">
      <v-col
        md="12"
        class="transition"
        :class="{
          'col-lg-8': !activityBoardCollapsed,
          'col-lg-12': activityBoardCollapsed,
        }"
      >
        <ToDo
          class="mb-6"
          data-testid="homeView-widget-toDo"
          data-tourid="home-to-do"
        />
        <Routines
          v-if="hasRoutinesFeatureEnabled"
          class="mb-6"
          data-testid="homeView-widget-routines"
          data-tourid="home-routines"
        />
        <Validations
          v-if="showValidationsWidget"
          class="mb-6"
          data-tourid="home-validations"
        />
        <TeamActivity
          class="mb-6"
          data-testid="homeView-widget-teamActivity"
          data-tourid="home-my-teams-activity"
        />
      </v-col>

      <v-col
        class="hidden-md-and-down col-lg-4 absolute-right transition"
        data-tourid="home-activity-board"
      >
        <ActivityBoard
          data-testid="homeView-widget-activityBoard"
          :isCollapsed="activityBoardCollapsed"
          @collapse="toogleActivityBoard"
        />
      </v-col>
    </v-row>
    <ReportsDrawer
      v-if="isReportsDrawerOpen"
      :organizationId="organizationId"
      :visible="isReportsDrawerOpen"
      @close="isReportsDrawerOpen = false"
    />
  </ViewContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import trackingMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'
import userMixin from '@/mixins/userMixin.vue'

import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import Routines from './Routines/Routines.vue'
import Validations from './Validations/Validations.vue'
import TeamActivity from './TeamActivity/TeamActivity.vue'
import ToDo from './ToDo/ToDo.vue'
import ActivityBoard from './ActivityBoard/ActivityBoard.vue'
import access from '@/lib/access.js'
import ReportsDrawer from '@/components/ReportsDrawer/ReportsDrawer.vue'

export default {
  name: 'HomeView',

  mixins: [trackingMixin, mixin, userMixin],

  components: {
    Routines,
    TeamActivity,
    ToDo,
    ViewContainer,
    ActivityBoard,
    Validations,
    ReportsDrawer,
  },

  data() {
    return {
      activityBoardCollapsed: false,
      isReportsDrawerOpen: false,
    }
  },

  mounted() {
    this.isReportsDrawerOpen = Boolean(
      this.getRouteQuery()?.isReportsDrawerOpen
    )

    this.trackHomeVisit()
  },

  computed: {
    ...mapGetters(['account', 'organizationId', 'organization']),

    hasRoutinesFeatureEnabled() {
      return Boolean(this.organization?.featuresEnabled__routines)
    },

    userName() {
      return this.getAvatarName(this.account)
    },

    showValidationsWidget() {
      return access.isFinancialCoach(this.account)
    },
  },

  methods: {
    toogleActivityBoard() {
      this.trackHomeCustomize({ section: 'activityBoard' })
      this.activityBoardCollapsed = !this.activityBoardCollapsed
    },
  },
}
</script>
<style lang="scss" scoped>
.absolute-right {
  position: absolute;
  right: 0px;
}

.transition {
  transition: 200ms ease all;
}
</style>
